import { render, staticRenderFns } from "./ExternalDamageDescription.vue?vue&type=template&id=2d509da9"
import script from "./ExternalDamageDescription.vue?vue&type=script&lang=ts"
export * from "./ExternalDamageDescription.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports